function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 1a.5.5 0 01.09.992L21 2h-1v11.39a1.91 1.91 0 013.125.205c.324.536.357 1.183.119 1.734l-.05.103.12.116c.475.498.729 1.178.68 1.88l-.018.175a2.48 2.48 0 01-1.85 2.056l-.123.015h-.028V21h.525a.5.5 0 01.09.992L22.5 22h-21a.5.5 0 01-.09-.992L1.5 21h.525v-1.326H2l-.123-.016a2.482 2.482 0 01-1.198-4.115l.112-.111-.038-.074a1.865 1.865 0 01-.164-.623l-.006-.164a1.904 1.904 0 011.4-1.829l.155-.035A1.911 1.911 0 014 13.412V2H3a.5.5 0 01-.09-.992L3 1h18zm-1 20v-1.76c.257.192.553.336.877.418l.123.016h.025V21H20zm-1 0V2H5v19h3v-4.5a.5.5 0 01.41-.492L8.5 16h7a.5.5 0 01.492.41l.008.09V21h3zM4 19.244c-.257.19-.552.333-.875.415l-.122.015h-.028V21H4v-1.756zM7.5 4h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm5 0h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm3 0h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-7 4h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm3 0h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm5 0h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm-9 4h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm5 0h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm3 0h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM3.27 14.112c.209.347.16.79-.118 1.084a.5.5 0 00-.128.249l-.01.105a.5.5 0 00.25.433c.52.302.805.887.721 1.48l-.025.135a1.48 1.48 0 01-.947 1.051l-.08.024H2.07l.054.016a1.485 1.485 0 01-.392-2.72.5.5 0 00.101-.78.868.868 0 01-.25-.614.91.91 0 011.687-.463zm18.882 1.084a.899.899 0 00.117-1.084.91.91 0 00-1.686.463c-.001.229.089.45.25.613a.5.5 0 01-.101.782 1.485 1.485 0 00.392 2.72l-.054-.017h.863l.08-.024a1.48 1.48 0 00.947-1.05l.025-.136a1.474 1.474 0 00-.721-1.48.5.5 0 01-.25-.433l.01-.105a.5.5 0 01.128-.25zM9 17h2.5v4H9v-4zm3.5 0H15v4h-2.5v-4z"
  }));
};
const SvgHotelsBrand = styled(BaseComponent).withConfig({
  displayName: "HotelsBrand__SvgHotelsBrand",
  componentId: "sc-r5rghc-0"
})(["outline:none;"]);
SvgHotelsBrand.isIcon = true;
SvgHotelsBrand.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgHotelsBrand;